<style lang="scss" scoped>
    .file-upload {
        &__element-remove,
        &__element-add {
            -webkit-appearance: none;
            padding: 0;
            border: 0;
            background-color: #00a8e1;
            height: 22px;
            width: 22px;
            color: #ffffff;
        }

        &__element {
            display: flex;
            margin-bottom: 10px;
        }

        &__element-remove {
            margin-right: 10px;
        }

        &__element--disabled {
            pointer-events: none;
        }

        &__element-remove.file-upload__element--disabled,
        &__element-add.file-upload__element--disabled {
            background-color: #cdcdcd !important;
        }
    }
</style>

<template>
    <div class="file-upload">
        <div class="file-upload__element" v-for="(attachment, index) in attachments" :key="attachment">
            <div class="file-upload__element-remove btn btn-primary" @click="removeAttachment(index)">-</div>
            <input class="file-upload__element-input" @change="handleAttachments(index)" ref="attachment" type="file"
                   name="file-upload-input" accept=".zip, .rar, .pdf, .xls, .xlsx, .doc, .docx, .xml">
        </div>
        <div class="file-upload__element-add btn btn-primary"
             v-bind:class="(attachments.length === parseInt(maxAttachmentCount)) ? 'file-upload__element--disabled' : ''"
             @click="addAttachment">+
        </div>
    </div>
</template>

<script>
    export default {
        name: "FileUpload",
        props: {
            maxAttachmentCount: {
                type: String,
                default: '5'
            }
        },
        data() {
            return {
                attachmentsCount: 0,
                attachments: [{
                    class: '',
                    value: ''
                }],
            };
        },
        methods: {
            addAttachment() {
                if (parseInt(this._props.maxAttachmentCount) === this.attachments.length + 1) {
                    this.attachments.push({
                        class: 'file-upload__element--disabled',
                        value: ''
                    })
                } else {
                    this.attachments.push({
                        class: '',
                        value: ''
                    })
                }
            },
            removeAttachment(index) {

                this.$delete(this.attachments, index);
            },
            removeAllAttachments() {
                this.attachments = [{
                    class: '',
                    value: ''
                }];
            },
            handleAttachments(index) {
                this.attachments[index].value = this.$refs.attachment[index].files;
                this.attachmentsCount++;
                let attachedFiles = this.attachments.map(function (attachment) {
                    if (attachment.value && attachment.value.length > 0) {
                        return attachment.value[0];
                    } else {
                        return null;
                    }
                });
                this.$emit('change', attachedFiles);
            }
        }
    };
</script>
